import { create } from "zustand";
import { persist } from "zustand/middleware";

export type OrdersTabKey = "orders" | "addresses" | "cards" | "preferences";

interface OrdersStore {
  // Tab Management
  activeTab: OrdersTabKey;

  // Actions
  setActiveTab: (tab: OrdersTabKey) => void;
}

const initialState = {
  activeTab: "orders" as OrdersTabKey,
};

export const useOrdersStore = create<OrdersStore>()(
  persist(
    (set) => ({
      ...initialState,

      // Tab Actions
      setActiveTab: (tab: OrdersTabKey) => {
        set({ activeTab: tab });
      },
    }),
    {
      name: "orders-storage",
      partialize: (state) => ({
        // Persist only activeTab
        activeTab: state.activeTab,
      }),
    }
  )
);

